import React from "react";

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
}


export const Link = React.forwardRef<HTMLAnchorElement, Props>(
  function LinkWithRef({ to, children, ...rest }, forwardedRef) {
    return (
      <a href={to} {...rest} ref={forwardedRef}>
        {children}
      </a>
    );
  }
);
